import { apiUrls } from '../../constants';
import { SessionStore } from '../../constants/sessionStore';
import { getCookie } from './cookies';
import { getToPost } from './getToPost';
import axios from '../../common/utils/interceptor';
import { getExperienceInitCookie } from './experienceInitCookie';
import { User } from '../../store/interfaces';
import { basicDetailsProvider } from '../../store/providers/basicDetailsProvider';

export const logoutUser = async (candidate: User): Promise<{ data?: { [index: string]: string }; error: string }> => {
  const res = { data: undefined, error: '' };

  const tcPlusFlow = getCookie('TcPlusFlag') === '1';
  const { updateUserSessionActive } = basicDetailsProvider();
  if (tcPlusFlow) {
    try {
      // get candidate email from session
      const candidateEmail = candidate && candidate.email;

      const { data } = await axios.post(apiUrls.TC_PLUS_LOGOUT, { email: candidateEmail });
      if (data.IsError) {
        res.error = data.Message;
      } else {
        res.data = data;
        sessionStorage.setItem(SessionStore.loggedoutuser, 'true');
        sessionStorage.removeItem(SessionStore.dpnAccepted);

        //update experience_props cookie
        const experienceProps = getExperienceInitCookie();
        if (experienceProps) {
          experienceProps.candidateExists = true;
          experienceProps.email = candidateEmail;
          experienceProps.mul = false;
        }
        sessionStorage.setItem(SessionStore.experienceProps, JSON.stringify(experienceProps));
        sessionStorage.setItem(SessionStore.basicTaskListHurdleIndicator, 'true');
        //set userSessionActive false
        updateUserSessionActive(false);
        sessionStorage.removeItem(SessionStore.formStatus);
      }
    } catch (error) {
      res.error = 'error';
      console.error('Failed while signing out.');
    }
  } else {
    sessionStorage.setItem(SessionStore.loggedoutuser, 'true');
    updateUserSessionActive(false);
    /** make API call to let backend know about user status */
    getToPost(apiUrls.LOGOUT);
  }
  return res;
};
